// Mirror of backend app/auth/permissions.py. Backend is authoritative;
// these strings only drive UI gating.
export const PERM = {
  COURSE_AUTHOR: 'course.author',
  COURSE_PUBLISH: 'course.publish',
  COURSE_ASSIGN: 'course.assign',
  COURSE_AI_GENERATE: 'course.ai_generate',
  MEMBER_MANAGE: 'member.manage',
  ANALYTICS_VIEW: 'analytics.view',
  PRIZE_MANAGE: 'prize.manage',
  GAMIFICATION_MANAGE: 'gamification.manage',
  PROGRAM_MANAGE: 'program.manage',
  BILLING_MANAGE: 'billing.manage',
  INTEGRATION_MANAGE: 'integration.manage',
  TEAM_MANAGE: 'team.manage',
  TENANT_MANAGE: 'tenant.manage',
} as const;

export type Permission = (typeof PERM)[keyof typeof PERM];
